// @flow
import _ from 'lodash';
import { getAppModuleConfig } from '../../../selectors/configSelectors';

const MODULE_NAME = 'emma-common';

export const getBannerRoutingDeepLink: any = (state: string) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `banner.routingDeepLink`, {
    host: 'emma-banner-routing',
    query: {
      promoCode: '${promoCode}',
      dob: '${dob}',
      gender: '${gender}',
      habbit: '${habbit}',
      landingUrl: '${landingUrl}',
      label: '${label}',
    },
  });
};

export const getBannerWebViewDeepLink: any = (state: string) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `banner.webViewDeepLink`, {
    host: 'emma-webview',
    query: {
      url: '${url}',
      isModal: true,
    },
  });
};

export const getDetailWebViewDeepLink: any = (state: string) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `banner.detailsDeepLink`, {
    host: 'emma-webview',
    query: {
      url: '${url}',
      label: '${label}',
      isHideBottomTabs: true,
    },
  });
};

export const getVhisWebViewDeepLink: any = (state: string) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `banner.vhisWebViewDeepLink`, {
    host: 'emma-webview/urlChange',
    query: {
      url: '${url}',
      label: '${label}',
      isModal: true,
      'urlChangeMonitor.monitorQuery': 'dob;gender;habbit',
      'urlChangeMonitor.isCloseWhenHitQuery': true,
      'urlChangeMonitor.deepLink': '${urlChangeMonitor.deepLink}',
    },
  });
};

export const getTopUpDeepLink = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `banner.topUpDeepLink`, {
    host: 'emma-webview',
    query: {
      url: `\${url}`,
      label: `\${label}`,
      blockLinks: ['https://m.youtube.com'],
      'headers.x-axa-context': `\${token}`,
      'headers.x-requested-with': 'com.axa.app.myaxa.hk',
    },
  });
};

export const getAioDomain: any = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `banner.aioDomain`, '');
};

export const getVhisDomain: any = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `banner.vhisDomain`, '');
};

export const getAioFilter = (state: any): string[] => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `banner.aioFilter`, ['/aio/api']);
};

export const getVhisFilter = (state: any): string[] => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `banner.vhisFilter`, ['/vhis-series']);
};

export const getLuckydrawFilter = (state: any): string[] => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, 'banner.luckydrawFilter', ['/luckdraw']);
};

export const getVhisIntermediaryPageLink: any = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `banner.vhisIntermediaryPageLink`, '');
};

export const getVhisApiLink: any = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(
    config,
    `banner.vhisApiLink`,
    'https://dev-www.axa.com.hk/en/vhis-eselling/api/eb-submit',
  );
};

export const getECommerceTokenApiLink: any = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(
    config,
    `banner.eCommerceTokenApiLink`,
    'https://st-papi.axa.com.hk/api/eFunnel/life/p2p/token?featureName=authJWT',
  );
};

export const getCorpWebDomain: any = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `corpWebDomain`, 'https://uat-www.axa.com.hk');
};

export const getTopUpLink: any = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  _.get(
    config,
    `banner.topUpLink`,
    '/${language}/myaxa/eb/emma/top-up-journey?policy_number=${policyNumber}&entity_code=${entityCode}&certificate_number=${certificateNumber}&dependentNo=${dependentNumber}',
  );
};

export const getBannerErrorMessage: any = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `banner.errorMessage`, {
    title: {
      en: 'Oops...Something went wrong',
      zh: '噢！錯誤',
    },
    content: {
      en: 'Sorry, there are some technical connect issues, please try again later.',
      zh: '對不起，出現技術性錯誤。請稍後再試。',
    },
    button: {
      en: 'OK, I will try again later.',
      zh: '好，稍後再試',
    },
  });
};

export const getTemplateId: any = (state: any, templateId: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  _.get(config, `share.${templateId}`, undefined);
};
